import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'duration',
  pure: true,
  standalone: false,
})
// Given a number of total seconds, return the duration in a viewer-friendly string
// (minutes:seconds or hours:minutes:seconds).
export class DurationPipe implements PipeTransform {
  transform(durationInSeconds: number | string): string {
    durationInSeconds = Number(durationInSeconds);

    if (!durationInSeconds || isNaN(durationInSeconds) || durationInSeconds < 0) {
      return '00:00';
    }

    const hours = Math.floor(durationInSeconds / 3600);
    const minutes = Math.floor((durationInSeconds % 3600) / 60);
    const seconds = Math.floor(durationInSeconds % 60);

    // 5 seconds turns into '05'
    const pad = (num: number): string => String(num).padStart(2, '0');

    return hours > 0
      ? `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`
      : `${pad(minutes)}:${pad(seconds)}`;
  }
}
